import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class WebChannelFeedConfig
*  Публичная конфигурация рекламного товарного фида витрины. По ней витрина решает, отдавать ли `/yandex.yml`, и как заполнять `<shop>`-шапку YML. Секретов в конфиге фида нет
*/
export class WebChannelFeedConfig extends ActiveModel {

  /**
  * enabled
  * Публиковать ли товарный фид витрины. При `false` витрина отдаёт по<br>`/yandex.yml` 404<br>  */
  @ActiveField(false)
  enabled: boolean = false


/**
  * shopName
  * Название магазина для `<shop><name>`. Уже с учётом фолбэка на<br>имя организации из SEO-настроек; если и оно пусто (`null`) — витрина<br>подставляет свой публичный домен<br>
  */
  @ActiveField(null)
  shopName: null | string = null


/**
  * companyName
  * Название компании для `<shop><company>`. Уже с учётом фолбэка на<br>Web.Api.Showcases.Controllers.Feed.Models.WebChannelFeedConfig.ShopName; если пусто (`null`) — витрина подставляет домен<br>
  */
  @ActiveField(null)
  companyName: null | string = null
}
